export default function () {
  if (window.location.hash && document.referrer === window.location.host) {
    const element = document.querySelector(window.location.hash)
    if (element) element.scrollIntoView({ behavior: 'smooth' })
  }
}
